import { Popconfirm, PopconfirmProps } from 'antd';
import { FC } from 'react';

const PopconfirmAtom: FC<PopconfirmProps> = ({ children, ...props }) => {
  return <Popconfirm {...props}>{children}</Popconfirm>;
};

export default PopconfirmAtom;
